// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"83a324a1","977":"e045ddc5"}[chunkId] + ".chunk.js";
};